import React, { useEffect } from "react";
import { createRoot } from "react-dom/client";
import { customTheme } from "common/customTheme";
import { ConfigProvider, App } from "antd";
import ErrorBox from "common/ErrorBox";
import { useIA } from "../Hooks/useIA";

export const Main = ({cat_user_id}) => {
    const context = useIA(cat_user_id);

    useEffect(() => {
        context.updateToken().then(() => context.fillText());
    }, []);


    return (
        <div>
            <div className="ant-table-title px-3 py-3 rounded my-2" style={{ margin: '0px 0em' }}>
                <div className="px-3" style={{ fontSize: '1.25rem' }}>Inteligencia artificial</div>
            </div>
            <div className="col-md-5 mt-3">
                <div className="mb-3">
                    <label className="form-label" htmlFor="">Texto:</label>
                    <textarea className="form-control" name="" id="" rows={10}
                        value={context.text}
                        onChange={(e) => context.setText(e.target.value)}
                    ></textarea>
                </div>
                <div className="text-end">
                    <button className="btn btn-sm btn-dark w-50"
                        onClick={context.updateText}
                    >
                        Guardar
                    </button>
                </div>
            </div>
        </div>
    );
}

let main = document.getElementById('ia-main');

if (main) {
    let cat_user_id = main.dataset.catUserId;
    if (!main.root) { main.root = createRoot(main); }
    main.root.render(
        <React.StrictMode>
            <ErrorBox>
                <ConfigProvider theme={customTheme}>
                    <App >
                        <Main cat_user_id={cat_user_id}/>
                    </App>
                </ConfigProvider>
            </ErrorBox>
        </React.StrictMode>
    );
}
